<template>
  <div class="my-presentation-box">
    <div>
      <portal to="my-presentation-sidebar" class="position-relative">
        <div
          v-if="foldersLoading"
          class="position-absolute d-flex justify-content-center py-20 w-100"
        >
          <wtr-loader class="d-block" variant="primary" addText></wtr-loader>
        </div>
        <div :class="{ 'fetch-class': foldersLoading }">
          <folders
            v-if="folders"
            :selectedFolder="selectedFolder"
            :activeFolder="activeFolder"
            :foldersLoading="foldersLoading"
            :rootFolder="rootFolder"
            :folders="folders"
            :copiedFolder="copiedFolder"
            :disableActions="true"
            @selected="folderSelected"
            @get-folders="getFolders()"
            @reset="resetPresentationFolders()"
            @temp-selected="selectedFolder = $event"
          ></folders>
        </div>
      </portal>
      <b-card no-body hide-footer>
        <div slot="header" class="fs-16 text-light" style="padding:2px 0px">
          <div class="d-flex justify-content-between">
            <span>
              <breadcrumbs v-if="typeof crumbs === 'object'" :items="crumbs" />
              <span v-else>{{ crumbs }}</span>
            </span>
          </div>
        </div>
        <b-card-body class="position-relative">
          <my-presentation-box
            ref="presentationBox"
            :currentFolder="currentFolder"
            :key="currentFolderKey"
            @create-new="createPresentation"
          ></my-presentation-box>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import BreadcrumbsComponent from "../../../components/common/breadcrumbs.vue";
import PresentationFoldersComponent from "../components/folders.vue";
import MyPresentationBoxComponent from "../components/my-presentation-box.vue";
import * as roleTypes from "../../../constants/constants-role";

export default {
  name: "MyPresentation",
  data() {
    return {
      ...roleTypes,
      foldersLoading: false,
      folders: [],
      selectedFolder: null,
      activeFolder: null,
      copiedFolder: null,
      rootFolder: null,
      currentFolder: null,
      currentFolderKey: 0,
    };
  },
  components: {
    "my-presentation-box": MyPresentationBoxComponent,
    folders: PresentationFoldersComponent,
    breadcrumbs: BreadcrumbsComponent,
  },
  computed: {
    ...mapGetters({
      sidebar: "getSidebar",
      crumbs: "getCrumbs",
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["renderSidebarAction", "sidebarAction"]),
    init() {
      this.renderSidebarAction("my-presentation-sidebar");
      this.sidebarAction({ show: true, full: true });
      this.$setHeaderAction(this.$t("common.myPresentations"));
      this.getFolders();
    },
    getFolders() {
      this.foldersLoading = true;
      this.folders = null;
      const userId = localStorage.getItem("userId");

      this.$api.getAllPresentationFolderByUserId(userId).then(
        (response) => {
          const payload = response && response.data && response.data.payload;
          this.buildPresentationFolders(payload || []);
          this.foldersLoading = false;
        },
        (error) => {
          this.$handleError(error);
          this.buildPresentationFolders([]);
          this.foldersLoading = false;
        }
      );
    },
    buildPresentationFolders(data) {
      const folders = Array.isArray(data)
        ? data
        : [...(data.publicBox || []), ...(data.userFolder || [])];

      const processedFolders = _.cloneDeep(folders).map((folder) => ({
        ...folder,
        text: folder.name,
        children: folder.children || [],
        opened: folder.opened || false,
        root: true,
        dropDisabled: true,
        dragDisabled: true,
      }));

      this.folders = processedFolders;
      this.rootFolder = _.cloneDeep(this.folders[0]);
      const active = this.folders[0] || null;
      this.activeFolder = active;
      this.selectedFolder = _.cloneDeep(active);
      this.folderSelected(active);
    },
    resetPresentationFolders() {
      this.copiedFolder = null;
      this.selectedFolder = _.cloneDeep(this.rootFolder);
    },
    folderSelected(node) {
      if (!node) {
        this.currentFolder = null;
        return;
      }

      this.activeFolder = node;
      this.selectedFolder = node;
      this.$setHeaderAction(node.name);
      this.currentFolder = node;
      this.currentFolderKey += 1;
    },
    createPresentation() {
      if (this.$refs.presentationBox) {
        this.$refs.presentationBox.openCreateModal();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  position: initial !important;
}
</style>
